export class TrackerGps {
  _id: string;
  type_trackerGps: number;
  status: number;
  imei: string;
  serial_number: string;
  timestamp_created: number;
  note: any[];
  status_trackerGps: number;
  timestamp_status_trackerGps: number[];
  current_config: number
  request_config: number
  type_sim: number;

  //consoe.log()
  private _$current_programming: any;
  private _$request_programming: any;
  request_config_start: number;
  request_config_end: number;
  request_config_sequence: string;
  request_config_command: string;
  request_config_status: string;

  /**
   * Orari di trasmissione configurati sul localizzatore Queclink (solo type_trackerGps === 6).
   * Popolato dal backend al ricevimento dell'ACK del comando AT@BSS=.
   * Formato: array di [ora, minuti], 1-3 elementi.
   * Es: [[9, 58], [13, 15], [18, 0]]
   */
  tx_schedule: number[][];

  private $getProgramming: (number) => any = () => {return undefined}

  constructor(data?: any, options?: { getProgramming?: (number) => any }) {
    console.log('TrackerGps', data);
    if(data){
      this.setData(data, options);
    }
  }
  
  setData(data: any, options? : { getProgramming?: (number) => any}){
    if(options){
      if(options.getProgramming) { this.$getProgramming = options.getProgramming}
    }
    if(data){
      this._id = data._id;
      this.type_trackerGps = data.type_trackerGps;
      this.status = data.status;
      this.imei = data.imei;
      this.serial_number = data.serial_number;
      this.timestamp_created = data.timestamp_created;
      this.note = data.note;
      this.status_trackerGps = data.status_trackerGps;
      this.timestamp_status_trackerGps = data.timestamp_status_trackerGps;
      this.type_sim = data.type_sim;

      this.request_config_start = data.request_config_start;
      this.request_config_end = data.request_config_end;
      this.request_config_sequence = data.request_config_sequence;
      this.request_config_command = data.request_config_command;
      this.request_config_status = data.request_config_status;

      // Sanitizzazione tx_schedule: accetta solo array di [h, m] con valori interi validi
      if(Array.isArray(data.tx_schedule)){
        this.tx_schedule = data.tx_schedule
          .filter((slot: any) => Array.isArray(slot) && slot.length === 2)
          .filter((slot: any[]) => Number.isInteger(slot[0]) && slot[0] >= 0 && slot[0] <= 23)
          .filter((slot: any[]) => Number.isInteger(slot[1]) && slot[1] >= 0 && slot[1] <= 59)
          .map((slot: number[]) => [slot[0], slot[1]]);
      }else{
        this.tx_schedule = undefined;
      }

      this.$current_programming = data.current_config;
      this.$request_programming = data.request_config;

    }
  }

  get $current_programming(): any{
    return this._$current_programming;
  }

  set $current_programming(value: any){
    this.current_config = value;
    this._$current_programming = this.$getProgramming(value);
  }
  get $request_programming(): any{
    return this._$request_programming;
  }

  set $request_programming(value: any){
    this.request_config = value;
    this._$request_programming = this.$getProgramming(value);
  }

}
